// @flow
import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames/bind'

import fail from 'app/common/images-runtime/fail.svg'

import styles from './RefillFail.module.scss'

const cx = classNames.bind(styles)

type Props = {
  phone?: string,
  compact?: boolean,
}

const RefillSuccess = ({ phone, compact }: Props) => {
  const { t } = useTranslation('finances')
  console.log({ fail })

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.message}>{t('pay_fail_message', 'Оплата не принята!')}</div>
        <div className={styles.comment}>
          {`${t('pay_fail_comment', 'Пожалуйста, обратитесь в\u00A0техническую поддержку')}`}
          {phone ? ':' : ''}
        </div>
        {phone && <div className={styles.phone}>{phone}</div>}
      </div>
      <img
        src={fail}
        alt={t('pay_fail_image_desc', 'Иллюстрация символизирующая неудачную оплату')}
        className={cx(styles.img, { compact })}
      />
    </div>
  )
}

export default RefillSuccess
